module.exports = __webpack_public_path__ + "static/Mano-ea5157e54d8cfc7efaf4305e23a57c30.png";